export interface User {
    id: string;
    name: string;
    email: string;
    password: string;
}

export interface Organization {
    id: string;
    name: string;
    logoUrl: string;
    perceptionUrl: string;
}

export interface FullUser extends Omit<User, 'password'> {
    organization: Organization;
    roles: string[];
    permissions: string[];
}

/** Roles ordered from highest to lowest privilege. */
const ROLE_PRIORITY: readonly string[] = [
    'admin',
    'member',
    'reader',
    'event-tagger',
] as const;

export function getHighestPrivilegedRole(roles: string[]): string | undefined {
    if (roles.length === 0) return undefined;

    return ROLE_PRIORITY.find((role) => roles.includes(role));
}
